const userReducer = (state = {}, action) => {
  //console.log( action.type , action , "1213456")
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        auth: action.data ,
        action : "LOGIN"
      };

      case "REGISTER_SUCCESS":
      return {
        ...state,
        auth: action.data ,
        action : "REGISTER"
      };

  }
  return state;
};
export default userReducer;
